import request from "@/utils/request";
import { client_secret, client_id, grant_type } from "@/config/auth";

export function loginByEmail(email, password) {
  const data = {
    username: email,
    password,
    client_id,
    client_secret,
    grant_type
  };
  return request({
    url: "/api/signin",
    method: "post",
    data
  });
}

export function logout() {
  return request({
    url: "/api/signout",
    method: "post"
  });
}

export function getUserInfo() {
  return request({
    url: "api/user",
    method: "get"
  });
}
